import React from "react";
import { ArrowRightIcon, CheckIcon, StarIcon } from "lucide-react";
import { images, volumes, Volume } from "../../data/content";
import { SectionHeading } from "../SectionHeading";
import { SectionCta } from "../SectionCta";
export function Volumes() {
  return <section className="bg-white px-5 py-16 md:py-24" data-id="element-326" data-mp="2x34j42h0ykiv">
      <div className="mx-auto max-w-4xl" data-id="element-327" data-mp="2syws1yn3gshh">
        <SectionHeading eyebrow="What you'll find inside" title={<>
              The Abdominoplasty <em className="italic text-gold-dark" data-id="element-329" data-mp="2j9d5ahw9gehc">Master System™</em>
            </>} intro="Six premium volumes that take you from your first observation to a lasting professional learning archive." data-id="element-328" data-mp="2t215lmmg90kt" />

        <img src={images.mockup} alt="The six volumes of The Abdominoplasty Master System" className="-mx-2 mt-8 w-[calc(100%+1rem)] max-w-none md:mx-auto md:w-full md:max-w-2xl" data-id="element-330" data-mp="29d0d5ogd68op" />

        <div className="mt-10 space-y-5" data-id="element-331" data-mp="20bsrc5v1b0bi">
          {volumes.map(v => <VolumeCard key={v.number} volume={v} data-id="element-332" data-mp="334uihy1ssjva" />)}
        </div>

        <SectionCta label="I want all 6 volumes" data-id="element-333" data-mp="37wma8bwowvn0" />
      </div>
    </section>;
}
function VolumeCard({
  volume: v
}: {
  volume: Volume;
}) {
  const dark = !!v.featured;
  return <article className={`rounded-3xl p-6 md:p-8 ${dark ? "bg-navy text-white ring-4 ring-gold" : "border border-navy/10 bg-cream text-navy"}`} data-id="element-334" data-mp="2y69sssk69il3">
      <div className="flex flex-wrap items-center gap-2" data-id="element-335" data-mp="3lu12doebvhio">
        <span className={`rounded-full px-3 py-1 text-xs font-black uppercase tracking-widest ${dark ? "bg-gold text-navy" : "bg-navy text-gold"}`} data-id="element-336" data-mp="3qu5nxsu3f2fr">
          Volume {v.number}
        </span>
        {v.featured && <span className="flex items-center gap-1 text-xs font-black uppercase tracking-widest text-gold" data-id="element-337" data-mp="21gacud1ozhsh">
            <StarIcon className="h-3.5 w-3.5 fill-current" aria-hidden="true" data-id="element-338" data-mp="26f3lns61akmb" />
            The heart of the system
          </span>}
      </div>
      <h3 className="mt-4 font-serif text-2xl font-black leading-tight md:text-3xl" data-id="element-339" data-mp="bydcy115ttd8">{v.title}</h3>
      <p className={`mt-3 text-[17px] font-semibold ${dark ? "text-gold" : "text-gold-dark"}`} data-id="element-340" data-mp="70u095k41one">{v.lead}</p>
      {v.body && <p className={`mt-3 text-[16px] leading-relaxed ${dark ? "text-white/80" : "text-navy/75"}`} data-id="element-341" data-mp="26z7lcmj1zc6">{v.body}</p>}

      {v.flow && <div className="mt-4 flex flex-wrap items-center gap-x-1.5 gap-y-2" data-id="element-342" data-mp="3pektbamxv8h8">
          {v.flow.map((f, i) => <React.Fragment key={f} data-id="element-343" data-mp="3kdx32r6javo2" data-mpi={i}>
              <span className="rounded-lg bg-navy px-2.5 py-1.5 text-xs font-extrabold uppercase tracking-wide text-white" data-id="element-344" data-mp="3kdne96x86ujy">
                {f}
              </span>
              {i < v.flow!.length - 1 && <ArrowRightIcon className="h-4 w-4 text-gold-dark" aria-hidden="true" data-id="element-345" data-mp="3bg39ho05mg4l" />}
            </React.Fragment>)}
        </div>}

      {v.listLabel && <p className={`mt-4 text-[16px] ${dark ? "text-white/80" : "text-navy/75"}`} data-id="element-346" data-mp="19nym8ptlo707">{v.listLabel}</p>}

      {v.items && <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-347" data-mp="2rifrrjr5815g">
          {v.items.map(item => <li key={item} className="flex items-start gap-2 text-[15px] leading-snug" data-id="element-348" data-mp="2whsfe6pu9c93">
              <CheckIcon className={`mt-0.5 h-4 w-4 shrink-0 ${dark ? "text-gold" : "text-cta"}`} aria-hidden="true" data-id="element-349" data-mp="31av8kdqpejor" />
              {item}
            </li>)}
        </ul>}

      {v.steps && <ol className="mt-4 space-y-2.5" data-id="element-350" data-mp="28nilm2gms9ux">
          {v.steps.map((s, i) => <li key={s} className="flex items-center gap-3 text-[15px] leading-snug" data-id="element-351" data-mp="2dlk5uqpsmf7z" data-mpi={i}>
              <span className="grid h-8 w-8 shrink-0 place-items-center rounded-full bg-gold font-serif text-base font-black text-navy" data-id="element-352" data-mp="2hlb1p8u6fljd">
                {i + 1}
              </span>
              {s}
            </li>)}
        </ol>}

      {v.closing && <p className={`mt-5 border-t pt-4 text-[16px] font-semibold leading-relaxed ${dark ? "border-white/15 text-white" : "border-navy/10 text-navy"}`} data-id="element-353" data-mp="1uydzsrdnsz2">
          {v.closing}
        </p>}
    </article>;
}